import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get materialRequest
export const getMaterialRequest = createAsyncThunk(
  "materialRequest/getMaterialRequest",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;

    try {
      const { data } = await API.getMaterialRequest({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all materialRequest
export const getAllMaterialRequest = createAsyncThunk(
  "materialRequest/getAllMaterialRequest",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllMaterialRequest();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("materialRequest/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("materialRequest/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "materialRequest/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;

    try {
      const { data } = await API.getPageMaterialRequest({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getMaterialRequestById = createAsyncThunk(
  "materialRequest/getMaterialRequestById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getMaterialRequestById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create materialRequest
export const createMaterialRequest = createAsyncThunk(
  "materialRequest/createMaterialRequest",
  async (createData, { rejectWithValue }) => {
    const {
      indentNo,
      isFromHo,
      requiredDateBs,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      receiverBranch,
      department,
      documentsAttach,
      materialRequestDetails,
      // requesterName,
      branch,
      discountAmount,
      grandTotal,
    } = createData;
    try {
      const body = JSON.stringify({
        indentNo,
        isFromHo,
        requiredDateBs,
        requiredDateAd,
        department,
        receiverBranch,
        voucherDateBs,
        voucherDate,
        purchaseOrderRequestDetails: materialRequestDetails,
        // requesterName,
        branch,
        discountAmount,
        grandTotal,
      });
      // const body = new FormData();

      // Object.entries(createData).forEach(([key, value]) => {
      //   if (key !== "documentsAttach" && key !== "materialRequestDetails") {
      //     body.append(key, value);
      //   }
      // });
      // documentsAttach?.length > 0 &&
      //   documentsAttach?.forEach((document, i) => {
      //     body.append(`documentsAttach[${i}]`, document);
      //   });
      // materialRequestDetails?.length > 0 &&
      //   materialRequestDetails?.forEach((detail, i) => {
      //     body.append(`purchaseOrderRequestDetails[${i}].product`, detail.product);
      //     body.append(`purchaseOrderRequestDetails[${i}].vendor`, detail.vendor);
      //     body.append(`purchaseOrderRequestDetails[${i}].actualQuantity`, detail.actualQuantity);
      //     body.append(`purchaseOrderRequestDetails[${i}].unit`, detail.unit);
      //     body.append(`purchaseOrderRequestDetails[${i}].rate`, detail.rate);
      //     body.append(`purchaseOrderRequestDetails[${i}].amount`, detail.amount);
      //     body.append(`purchaseOrderRequestDetails[${i}].requiredDate`, detail.requiredDate);

      //     body.append(`purchaseOrderRequestDetails[${i}].closingStock`, detail.closingStock);

      //     body.append(`purchaseOrderRequestDetails[${i}].description`, detail.description);

      //     body.append(`purchaseOrderRequestDetails[${i}].altQuantity`, detail.altQuantity);

      //     body.append(`purchaseOrderRequestDetails[${i}].altUnit`, detail.altUnit);
      //   });
      const { data } = await API.createMaterialRequest(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateMaterialRequest = createAsyncThunk(
  "materialRequest/updateMaterialRequest",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { documentsAttach, materialRequestDetails } = values;
    try {
      const body = new FormData();

      Object.entries(values).forEach(([key, value]) => {
        if (key !== "documentsAttach" && key !== "materialRequestDetails") {
          body.append(key, value);
        }
      });
      documentsAttach?.length > 0 &&
        documentsAttach?.forEach((document, i) => {
          body.append(`documentsAttach[${i}]`, document);
        });
      materialRequestDetails?.length > 0 &&
        materialRequestDetails?.forEach((detail, i) => {
          body.append(`purchaseOrderRequestDetails[${i}].product`, detail.product);
          body.append(`purchaseOrderRequestDetails[${i}].vendor`, detail.vendor);
          body.append(`purchaseOrderRequestDetails[${i}].actualQuantity`, detail.actualQuantity);
          body.append(`purchaseOrderRequestDetails[${i}].unit`, detail.unit);
          body.append(`purchaseOrderRequestDetails[${i}].rate`, detail.rate);
          body.append(`purchaseOrderRequestDetails[${i}].amount`, detail.amount);
          body.append(`purchaseOrderRequestDetails[${i}].requiredDate`, detail.requiredDate);
          if (detail.closingStock) {
            body.append(`purchaseOrderRequestDetails[${i}].closingStock`, detail.closingStock);
          }
          if (detail.description) {
            body.append(`purchaseOrderRequestDetails[${i}].description`, detail.description);
          }
          if (detail.altQuantity) {
            body.append(`purchaseOrderRequestDetails[${i}].altQuantity`, detail.altQuantity);
          }
          if (detail.altUnit) {
            body.append(`purchaseOrderRequestDetails[${i}].altUnit`, detail.altUnit);
          }
        });
      const { data } = await API.updateMaterialRequest(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "materialRequest/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
